export default "__VITE_ASSET__BUoXt0DF__"